// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__bBND1","buttons":"RemoveExpirationActionButtons_buttons__3ay7o"};